.m-toggle {
  display: inline-flex;
  align-items: center;

  &__input {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;

    &:focus-visible + .m-toggle__label .m-toggle__track {
      outline: 2px solid var(--theme-accent-blue);
      outline-offset: 2px;
    }

    &:checked + .m-toggle__label .m-toggle__track {
      background-color: var(--theme-accent-blue);

      .m-toggle__thumb {
        transform: translateX(16px);
      }
    }
  }

  &__label {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    user-select: none;
  }

  &__track {
    position: relative;
    width: 34px;
    height: 18px;
    background-color: var(--grey-lightest-non-text);
    border-radius: 9px;
    transition: background-color 0.2s ease;
    flex-shrink: 0;
  }

  &__thumb {
    position: absolute;
    top: 2px;
    left: 2px;
    width: 14px;
    height: 14px;
    background-color: white;
    border-radius: 50%;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
    transition: transform 0.2s ease;
  }

  &__text {
    font-size: 14px;
    line-height: 150%;
    color: var(--text-color);
  }
}
